import React from 'react';
import { tournoiDataSet } from '../../data/tournoiData';
import TournoiCard from './TournoiCard';

function TournoiPage() {

    return (
        <main className="container text-white py-5">
            <>
                <h1 className="py-5">Welcome to the Golf Tournement</h1>
                <div className="row row-cols-1 row-cols-md-3 mb-3 text-center">
                    {tournoiDataSet.map((tournoi, index) => (
                        <div className="col-md-4" key={index}>
                            <TournoiCard tournoi={tournoi} />
                        </div>
                    ))}
                </div>
            </>
        </main>
    )
}

export default TournoiPage